<mat-toolbar class="header-toolbar">
  <div class="header-content">
    <!-- Mobile Menu Button -->
    <button mat-icon-button class="mobile-menu-button" (click)="toggleMobileMenu()" aria-label="Toggle navigation menu">
      <mat-icon>menu</mat-icon>
    </button>

    <!-- Logo/Brand -->
    <div class="brand">
      <img class="brand-logo" src="logo.svg" [alt]="titleService.getTitle()" width="91" height="40"
        aria-label="Trigenia - CAR+ Logo" />
      <span class="brand-text">{{ titleService.getTitle() }}</span>
    </div>

    <!-- Right section: language + user menu -->
    <div class="header-right">
      <!-- Language selector (flag + dropdown) -->
      <div class="lang-selector">
        <button mat-button [matMenuTriggerFor]="langMenu" type="button" class="lang-trigger"
          [attr.aria-label]="'common.selectLanguage' | transloco">
          <span class="lang-flag" aria-hidden="true">
            @if (activeLang$ | async; as activeCode) {
            @for (lang of availableLangs; track lang.code) {
            @if (lang.code === activeCode) {
            {{ lang.flag }}
            }
            }
            }
          </span>
          <mat-icon class="lang-chevron">arrow_drop_down</mat-icon>
        </button>
        <mat-menu #langMenu="matMenu" class="lang-dropdown">
          @for (lang of availableLangs; track lang.code) {
          <button mat-menu-item type="button" (click)="setLanguage(lang.code)"
            [class.active]="(activeLang$ | async) === lang.code">
            <span class="lang-option-flag">{{ lang.flag }}</span>
            <span class="lang-option-label">{{ lang.label }}</span>
          </button>
          }
        </mat-menu>
      </div>

      <!-- User Menu -->
      <div class="user-menu">
        @if (authenticated()) {
        @if (userProfile(); as user) {
        <button mat-button [matMenuTriggerFor]="userMenu" class="user-button">
          <div class="user-avatar">
            @if (user.avatar) {
            <img [src]="user.avatar" [alt]="user.name" class="user-avatar-image" aria-label="{{ user.name }}">
            } @else {
            <span class="user-initials">{{ user.initials }}</span>
            }
          </div>
          <mat-icon>keyboard_arrow_down</mat-icon>
        </button>
        }
        }

        <mat-menu #userMenu="matMenu" class="user-dropdown">
          <button mat-menu-item (click)="onProfileClick()">
            <mat-icon>person</mat-icon>
            <span>{{ 'common.profile' | transloco }}</span>
          </button>
          <button mat-menu-item (click)="onSettingsClick()">
            <mat-icon>settings</mat-icon>
            <span>{{ 'common.settings' | transloco }}</span>
          </button>
          <mat-divider></mat-divider>
          <button mat-menu-item (click)="onLogout()">
            <mat-icon>logout</mat-icon>
            <span>{{ 'common.logout' | transloco }}</span>
          </button>
        </mat-menu>
      </div>
    </div>
  </div>
</mat-toolbar>